<button
  app-button
  buttonType="outline"
  buttonShape="circle"
  [matMenuTriggerFor]="userActions"
  [matTooltip]="(userProfile$ | async)?.email"
  *ngIf="userProfile$ | async">
  <!-- <span class="text-bold text-14 text-uppercase">{{ initials }}</span> -->
  <fa-icon icon="user"></fa-icon>
</button>

<mat-menu #userActions="matMenu">    
  <button *ngIf="!isPremiumAccount" mat-menu-item (click)="handleUpgradeSubscription()"><span class="profile-cta">Upgrade to Premium</span></button>
  
  <mat-divider *ngIf="!isPremiumAccount"></mat-divider>

  <button mat-menu-item (click)="handleProfile()">My Profile</button>
  <button mat-menu-item *ngIf="isGroupAccount" (click)="handleGroupAccount()">Invite Members...</button>
  <button mat-menu-item (click)="handleDeveloperAccount()">Developer Account...</button>
  
  <mat-divider></mat-divider>

  <button mat-menu-item (click)="handleAbout()">About BioDigital...</button>
  
  <mat-divider></mat-divider>

  <button mat-menu-item (click)="handleLogout()">Logout</button>
</mat-menu>
